<template>
    <div  id="elementHint">
        <el-dialog
                title="提示"
                :visible.sync="hintShow"
                width="20%"
                v-if="hintShow"
        >
            <div style="display: flex;width: 100%;justify-content:center;">
                <i class="el-icon-warning" style="color:#faad14;font-size: 25px;"></i>
                <div>
                    <div class="f16">{{main}}</div>
                    <div class="f14">{{main2}}
                        <span style="color: #e90e24" class="f14">{{redMain}}</span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                  <el-button  @click="hintConfire" class="confire" type="primary_redirect" size="small" :loading="hintLoading">确 定</el-button>
                   <el-button @click="closeifsee" size="small" type="cancel_blue">取 消</el-button>
             </span>
        </el-dialog>
    </div>

</template>

<script>
    export default {
        name: "elementHint",
        props:{
            main:{
              type:String
            },
            main2:{
              type:String
            },
            redMain:{
              type:String
            }
        },
        data:function(){
            return{
                hintShow: false,
                hintLoading: false,
            }
        },
        methods:{
            hintConfire(){
              this.hintLoading = true
              this.$emit("hintConfire");
            },
            ifsee(){
              this.hintShow=true
            },
            closeifsee(){
              this.$emit("closeHint");
              this.hintShow=false
              this.hintLoading = false
            }

        }
    }
</script>

<style lang="scss">
    #elementHint{
        .el-dialog__wrapper{
            display: flex;
            align-items: center;
        }
        .el-dialog{
            border-radius: 4px;
            margin-top: 0!important;
        }
        .el-dialog__body{
            padding: 20px;
        }
        .el-button--primary_redirect{
            background:#cfa972;
            border-color:#cfa972 ;
            color: #fff;
        }
        .el-button--primary_redirect:active,.el-button--primary_redirect:focus, .el-button--primary_redirect:hover{
            background: #cfa972!important;
            border-color:#cfa972!important;
            color: #fff;
        }
        .f16{
            font-size: 16px;
        }
        .f14{
            font-size: 14px;
        }
    }

</style>
